module.exports = __webpack_public_path__ + "img/googlestore_page.fa510ad.png";